import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Header.css";
import "tailwindcss/tailwind.css";

// Imported Images
import Logo from "../Header/imgs/logo.jpg";

//* React-Icons

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header id="head">
      <nav className="bg-white shadow-lg border-gray-200 px-4 lg:px-6 py-3 dark:bg-gray-800">
        <div className="flex flex-wrap justify-between items-center mx-auto max-w-screen-xl">
          {/* Logo and Title */}
          <Link to="/" className="flex items-center">
            <img
              src={Logo}
              className="mr-3 w-96 sm:w-80 md:w-60 lg:w-96 h-auto transition-all duration-300"
              alt="Logo"
            />
            <div className="flex flex-col text-gray-800 dark:text-white"></div>
          </Link>

          {/* Mobile Menu Button */}
          <div className="lg:hidden mt-2">
            <button
              onClick={toggleMenu}
              className="p-2 text-gray-500 rounded-lg hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600">
              {isMenuOpen ? (
                <svg
                  className="w-6 h-6"
                  viewBox="0 0 20 20"
                  fill="currentColor">
                  <path
                    fillRule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              ) : (
                <svg
                  className="w-6 h-6"
                  viewBox="0 0 20 20"
                  fill="currentColor">
                  <path
                    fillRule="evenodd"
                    d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                    clipRule="evenodd"
                  />
                </svg>
              )}
            </button>
          </div>

          {/* Navigation Links */}
          <div
            className={`lg:flex lg:items-center mt-3 lg:w-auto ${
              isMenuOpen ? "block" : "hidden"
            } w-full lg:block`}>
            <ul className="flex flex-col lg:flex-row lg:space-x-8 text-center lg:text-left">
              <li>
                <Link
                  to="/"
                  className="block py-2 px-4 text-lg dark:text-gray-200 hover:text-red-500 transition-all">
                  الرئيسية
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="block py-2 px-4 text-lg dark:text-gray-200 hover:text-red-500 transition-all">
                  الخدمات
                </Link>
              </li>
              <li>
                <Link
                  to="/aboutUs"
                  className="block py-2 px-4 text-lg dark:text-gray-200 hover:text-red-500 transition-all">
                  عن الشركة
                </Link>
              </li>
              <li>
                <Link
                  to="/contactUs"
                  className="block py-2 px-4 text-lg dark:text-gray-200 hover:text-red-500 transition-all">
                  تواصل معنا
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Header;
